module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"label-locale":"Sprache","label-templates":"Template","label-format":"Format","label-auto-reload":"Auto-Reload"}}')
  delete Component.options._Ctor
}
